import { useQuery } from '@tanstack/react-query'

import { getSupplierMe } from './api'

export const SUPPLIER_ME_QUERY_KEY = ['supplier-me']

export function useSupplierMe() {
  return useQuery({
    queryKey: SUPPLIER_ME_QUERY_KEY,
    queryFn: ({ signal }) => getSupplierMe(signal)
  })
}
